
import debounce from 'lodash/debounce'
import { mapState, mapMutations } from 'vuex'
import { useDispatchStoreAction } from '~/mixins/DispatchStoreAction.js'

export default {
  mixins: [
    useDispatchStoreAction({
      action: 'coupons/redeemCoupon',
      successTextKey: 'successfully-redeemed',
    }),

    useDispatchStoreAction({
      action: 'coupons/getDetails',
      name: 'storeActionCheckCoupon',
    }),
  ],

  inject: ['wizard'],

  authRedirectLogin: '/coupons/redeem/login',
  middleware: 'auth',

  data() {
    return {
      couponCode: this.$route.query.coupon,
      error: '',
      coupon: null,
    }
  },

  head() {
    return {
      title: this.redeemCouponPageSettings.enter_code_form_title,
    }
  },

  computed: {
    ...mapState('global', ['redeemCouponPageSettings']),

    user() {
      return this.$auth.user
    },
  },

  // write a watcher which will debounced check the entered coupon after it is more than 6 characters long
  watch: {
    couponCode: {
      handler: debounce(function (value) {
        this.checkCoupon()
      }, 500),

      immediate: true,
    },
  },

  methods: {
    ...mapMutations('coupons', ['setCoupon']),

    stepIsInvalid(validated, invalid) {
      return (
        this.storeAction.state === 'loading' ||
        this.storeActionCheckCoupon.state === 'loading' ||
        (validated && invalid)
      )
    },

    async checkCoupon() {
      this.error = ''

      if (!this.couponCode) {
        this.setCoupon(null)
        return
      }

      try {
        const coupon = await this.dispatchStoreActionCheckCoupon(
          this.couponCode,
          {
            silentOnError: true,
            silentOnSuccess: true,
          }
        )

        this.coupon = coupon
        this.setCoupon(coupon)
      } catch (error) {
        console.log({ error })
        this.coupon = null
        this.setCoupon(null)
      }
    },

    async submit() {
      await this.$refs.observer.validate()

      if (this.coupon.has_multiple_supported_coupon_platforms) {
        this.wizard.goNext({ coupon: this.couponCode })
        return
      }

      this.error = ''

      const redeemForPlatform = this.coupon.redeemable_at_platforms[0]

      // Submit coupon code for redemption
      try {
        const coupon = await this.dispatchStoreAction(
          {
            code: this.couponCode,
            redeemForPlatform,
          },
          {
            silentOnError: true,
          }
        )

        this.$debug(
          `User with id ${this.user.id} successfully redeemed coupon "${coupon.code}"`
        )

        this.error = ''

        // If it has been redeemed successfully go to next route
        this.wizard.goNext({ coupon: coupon.code })
      } catch (error) {
        console.log({ error })
        if ([404, 422].includes(error.response?.status)) {
          this.error = this.$t(
            'this-coupon-is-invalid-or-has-been-redeemed-already'
          )
        } else {
          this.error = this.$t('error')
        }
      }
    },
  },
}
